<div class="jh-popup">
  <div class="jh-btn-exit">
    <div class="ps-d-button-container">
      <i class="fas fa-times" (click)="close()" onkeypress="close()"></i>
    </div>
  </div>

  <mat-dialog-content>
    <div class="row">
      <div class="col">
        We noticed you updated your response in the {{mismatchWarningStrings}} field(s), and that an illustration was
        previously uploaded. <br /><br />
        To avoid unnecessary delays, please confirm that the details in the illustration match the newly-updated
        application
        information, and upload a new illustration if necessary.

        <mat-dialog-actions>
          <button class="btn btn-primary disclosure-button" (click)="this.close()">Continue</button>
        </mat-dialog-actions>
      </div>
    </div>
  </mat-dialog-content>
  
</div>
